module.exports = __webpack_public_path__ + "static/media/Catalyte Event 4.1.19.4a53a44d.jpg";